module.exports = __webpack_public_path__ + "media/feedback-4-63944a26b40898689e16edb6c1f4504d.gif";